import { render, staticRenderFns } from "./TelegramMenus.vue?vue&type=template&id=2fe7851a&scoped=true"
import script from "./TelegramMenus.vue?vue&type=script&lang=js"
export * from "./TelegramMenus.vue?vue&type=script&lang=js"
import style0 from "./TelegramMenus.vue?vue&type=style&index=0&id=2fe7851a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe7851a",
  null
  
)

export default component.exports